import { CircularProgress } from '@mui/material';

const RouteLoadingFallback = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '200px',
        width: '100%',
      }}
    >
      <CircularProgress size={64} />
    </div>
  );
};

export default RouteLoadingFallback;
